import { Account } from '@/domain/usecases'

export namespace AccountRole {
  export class Enum {
    static readonly COMPANY_MANAGER = new Enum('COMPANY_MANAGER')
    static readonly TEAM_MANAGER = new Enum('TEAM_MANAGER')
    static readonly INTERNAL_COMPANY_MANAGER = new Enum('INTERNAL_COMPANY_MANAGER')
    static readonly USER_DEPENDENT = new Enum('USER_DEPENDENT')
    static readonly SYSTEM_MANAGER = new Enum('SYSTEM_MANAGER')

    private constructor(public readonly name: string) {}

    public is(account: Account.Model): boolean {
      return AccountRole.contains(AccountRole.Enum.COMPANY_MANAGER, account.roles)
    }

    public isNot(account: Account.Model): boolean {
      return !this.is(account)
    }
  }

  export const findByName = (name?: string | null): AccountRole.Enum | undefined => {
    return name && Object.values(AccountRole.Enum).find(r => r.name === name)
  }

  export const contains = (role: AccountRole.Enum, roles: AccountRole.Enum[]): boolean => {
    return Object.values(roles).some(r => r != null && r.name === role.name)
  }
}
